import { render, staticRenderFns } from "./sparepartSection.vue?vue&type=template&id=5080347c&scoped=true"
import script from "./sparepartSection.vue?vue&type=script&lang=js"
export * from "./sparepartSection.vue?vue&type=script&lang=js"
import style0 from "./sparepartSection.vue?vue&type=style&index=0&id=5080347c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080347c",
  null
  
)

export default component.exports